import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { connect, useDispatch } from "react-redux";
import moment from "moment/moment";
import { deleteFreeLinks, getFreeLinks, setFreeLinksIsBusy, setFreeTrials } from "../../../../redux/actions/promotions";
import copy from "copy-to-clipboard";
import AlertConfirmModal from '../../../common/AlertConfirmModal';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, OutlinedInput, Select, TextField } from '@mui/material';
import styled from 'styled-components';

import './style.scss';
import pusher from '../../../utils/pusher';

import store from '../../../../redux/reducers/reducer';

const FormContainer = styled.div`
    margin-top: 16px;
`;

const TrialLinks = ({
    userId,
    freeTrials,
    isBusy,
}) => {
    const dispatch = useDispatch();
    const [openForm, setOpenForm] = useState(false);
    const [formData, setFormData] = useState({
        trial_name: '',
        limit_users: 10,
        offer_duration: 30,
        limit_days: 7
    });
    const [errors, setErrors] = useState({
        trial_name: '',
        limit_users: '',
        offer_duration: '',
        limit_days: ''
    });
    const [modalBody, setModalBody] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [hasConfirm, setHasConfirm] = useState(false);
    const [selectedTrial, setSelectedTrial] = useState(null);
    const [channelName, setChannelName] = useState('');
    const [channel, setChannel] = useState(null);

    const showFormModal = () => {
        setOpenForm(!openForm);
    };

    const handleCancel = (e) => {
        setOpenForm(false);
        setFormData({});
    };

    useEffect;

    const handleSubmit = (e) => {
        dispatch(setFreeLinksIsBusy(true));
        axios.post('/api/create-free-trial-link', formData)
            .then((response) => {
                if (response.data.success) {
                    setOpenForm(false);
                    setFormData({
                        trial_name: '',
                        limit_users: 10,
                        offer_duration: 30,
                        limit_days: 7
                    });
                    dispatch(getFreeLinks());
                }
            })
            .catch((error) => {
                console.log('Cannot process free trial link');
                if (error.response) {
                    if (error.response.status === 422) {
                        const responseData = error.response.data;
                        const firstErrorKey = Object.keys(responseData.errors);
                        console.log("🚀 ~ handleSubmit ~ firstErrorKey:", firstErrorKey);
                        // responseData.errors[firstErrorKey[0]]

                        setErrors({
                            ...errors,
                            [firstErrorKey[0]]: responseData.errors[firstErrorKey[0]]
                        });
                    }
                }
            })
            .finally(() => {
                dispatch(setFreeLinksIsBusy(false));
            });
    };

    const handleCloseConfirmation = () => {
        setShowAlert(false);
    };

    const handleCopy = (e, link) => {
        copy(link, { debug: false, message: 'Click to copy caption' });
        setShowAlert(true);
        setModalBody("Free link successfully copied");
    };

    const handleDelete = (e, trial) => {
        dispatch(deleteFreeLinks(trial.link));
        setShowAlert(true);
        setModalBody("Free link successfully deleted");
    };

    useEffect(() => {
        let mounted = true;
        dispatch(getFreeLinks());
        setChannelName(`private-free-trial-${userId}`);
        return (() => { return mounted = false; });
    }, []);

    const handleDeleteConfirm = (e, trial) => {
        setSelectedTrial(trial);
        setModalBody('Are you sure you want to delete this link?');
        setConfirmDelete(true);
        setHasConfirm(true);
    };

    const handleNameChange = e => {
        setFormData({
            ...formData,
            trial_name: e.target.value
        });
        setErrors({
            ...errors,
            trial_name: ''
        });
    };

    const handleLimitUsersChange = e => {
        setFormData({
            ...formData,
            limit_users: e.target.value
        });
    };

    const handleLimitDaysChange = e => {
        setFormData({
            ...formData,
            limit_days: e.target.value
        });
    };

    const handleOfferDurationChange = e => {
        setFormData({
            ...formData,
            offer_duration: e.target.value
        });
    };

    const updateSubCount = data => {
        const storeTrials = store.getState().promotions.trials;
        let tmp = [...storeTrials];
        const index = tmp.findIndex(t => t.id == data.trialId);

        if (index >= 0) {
            tmp[index].subs_count = data.subsCount;
            dispatch(setFreeTrials([...tmp]));
        }

    };

    useEffect(() => {
        if (channelName) {
            console.log("🚀 ~ useEffect ~ channelName:", channelName);
            setChannel(pusher.subscribe(channelName));
        }
    }, [channelName]);

    useEffect(() => {
        if (channel) {
            channel.bind('App\\Events\\FreeTrialSubscriptionEvent', (d) => {
                console.log("🚀 ~ channel.bind ~ d:", d);
                updateSubCount(d);
            });

            console.log("🚀 ~ channel.bind ~ d: DONE");
        }

        return () => {
            pusher.unsubscribe(channelName);
        };
    }, [channel]);

    return <>
        <div className="promotionpanel-fields">
            <div className={`promotion-field-group trial-link-field-group`}>
                <div className="profile-form-button promotional-btns create-link-button mb-2" onClick={showFormModal}>
                    <button
                        className="btn theme-btn theme-btn-bordered"
                        disabled={openForm || isBusy}
                    >
                        Create New Free Trial Link
                    </button>
                </div>
                {
                    freeTrials && freeTrials.length > 0 && <div className="promo__status mb-4 panel-title text-left">
                        <span>TRIAL LINKS</span>
                    </div>
                }
                <div className={'free-trial-links-container'}>
                    {
                        freeTrials && freeTrials.length > 0 && freeTrials.map((trial, index) => {
                            return <div key={`${trial.id}`}>
                                <div id={`free-trial-${trial.id}`} className={'link-container'}>
                                    <div className={'link-name'}>{trial.trial_name} ({trial.trial_period} free trial)</div>
                                    <div className={'link-detail-container'}>
                                        <div className={'link-detail free-trial-created-at'}>
                                            <span>Link Created</span>
                                            <span>{moment(trial.created_at).format('ll')}</span>
                                        </div>
                                        <div className={`link-detail free-trial-expires ${trial.has_expired ? 'has-expired' : ''}`}>
                                            <span>{`Link ${trial.has_expired ? 'Expired' : 'Expires'}`}</span>
                                            <span>
                                                {
                                                    trial.limit_days === 0
                                                        ? 'No Expiration'
                                                        : moment.utc(trial.expiration).local().format('ll')
                                                }
                                            </span>
                                        </div>
                                        <div className={'link-detail free-trial-offer-limit'}>
                                            <span>Offer Limit</span>
                                            <span>{trial.limit_users}</span>
                                        </div>
                                        <div className={'link-detail free-trial-subscribers'}>
                                            <span>Subscribers</span>
                                            <span>{trial.subs_count}</span>
                                        </div>
                                    </div>
                                    <div className={'link-action-buttons'}>
                                        <button className={'delete-btn'} onClick={(e) => handleDeleteConfirm(e, trial)}>Delete</button>
                                        {
                                            !trial.has_expired && <button className={'copy-btn'} onClick={(e) => handleCopy(e, trial.url)}>Copy Link</button>
                                        }
                                    </div>
                                </div>
                                <hr />
                            </div>;
                        })
                    }
                </div>
            </div>
        </div>
        {
            openForm
                ? <Dialog
                    open={openForm}
                    onClose={showFormModal}
                    className='free-trial-modal'
                    aria-labelledby="free-trial-title"
                    aria-describedby="free-trial-description"
                >
                    <DialogTitle>Free Trial Link</DialogTitle>
                    <DialogContent>
                        <FormContainer>
                            <TextField
                                type='text'
                                variant='outlined'
                                label='Unique Name'
                                size='small'
                                value={formData.trial_name}
                                onChange={handleNameChange}
                                fullWidth
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '20px',
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        background: 'transparent !important'
                                    }
                                }}
                                error={!!errors.trial_name}
                                helperText={errors.trial_name}
                            />
                        </FormContainer>
                        <div className='limits'>
                            <FormContainer>
                                <FormControl fullWidth>
                                    <InputLabel id="limit-users-label">Offer Limit</InputLabel>
                                    <Select
                                        native
                                        labelId='limit-users-label'
                                        size='small'
                                        name='limit_users'
                                        value={formData.limit_users}
                                        onChange={handleLimitUsersChange}
                                        label='Offer Limit'
                                        sx={{
                                            borderRadius: '20px',
                                            '& .MuiOutlinedInput-input': {
                                                background: 'transparent !important'
                                            }
                                        }}
                                    >
                                        <option value={0}>No Limits</option>
                                        <option value={1}>1 Subscriber</option>
                                        <option value={2}>2 Subscribers</option>
                                        <option value={3}>3 Subscribers</option>
                                        <option value={4}>4 Subscribers</option>
                                        <option value={5}>5 Subscribers</option>
                                        <option value={6}>6 Subscribers</option>
                                        <option value={7}>7 Subscribers</option>
                                        <option value={8}>8 Subscribers</option>
                                        <option value={9}>9 Subscribers</option>
                                        <option value={10}>10 Subscribers</option>
                                        <option value={25}>25 Subscribers</option>
                                        <option value={50}>50 Subscribers</option>
                                        <option value={100}>100 Subscribers</option>
                                    </Select>
                                </FormControl>
                            </FormContainer>
                            <FormContainer>
                                <FormControl fullWidth>
                                    <InputLabel id='limit-days-label'>Offer Expiration</InputLabel>
                                    <Select
                                        native
                                        labelId='limit-days-label'
                                        size='small'
                                        name='limit_days'
                                        value={formData.limit_days}
                                        onChange={handleLimitDaysChange}
                                        label='Offer Expiration'
                                        sx={{
                                            borderRadius: '20px',
                                            '& .MuiOutlinedInput-input': {
                                                background: 'transparent !important'
                                            }
                                        }}
                                    >
                                        <option value={0}>No Expiration</option>
                                        <option value={1}>1 Day</option>
                                        <option value={2}>2 Days</option>
                                        <option value={3}>3 Days</option>
                                        <option value={4}>4 Days</option>
                                        <option value={5}>5 Days</option>
                                        <option value={6}>6 Days</option>
                                        <option value={7}>7 Days</option>
                                        <option value={14}>14 Days</option>
                                        <option value={30}>30 Days</option>
                                    </Select>
                                </FormControl>
                            </FormContainer>
                        </div>
                        <FormContainer>
                            <FormControl fullWidth>
                                <InputLabel id="duration-label">Duration</InputLabel>
                                <Select
                                    native
                                    name='offer_duration'
                                    labelId='duration-label'
                                    size='small'
                                    value={formData.offer_duration}
                                    onChange={handleOfferDurationChange}
                                    label='Duration'
                                    sx={{
                                        borderRadius: '20px',
                                        '& .MuiOutlinedInput-input': {
                                            background: 'transparent !important'
                                        }
                                    }}
                                >
                                    <option value={1}>1 Day</option>
                                    <option value={7}>7 Days</option>
                                    <option value={14}>14 Days</option>
                                    <option value={30}>1 Month</option>
                                    <option value={90}>3 Months</option>
                                    <option value={180}>6 Months</option>
                                    <option value={365}>12 Months</option>
                                </Select>
                            </FormControl>
                        </FormContainer>
                    </DialogContent>
                    <DialogActions>
                        {
                            !isBusy ? <Button
                                type="button"
                                onClick={handleCancel}
                            >Cancel</Button>
                                : null
                        }
                        <Button
                            onClick={handleSubmit}
                            disabled={isBusy}
                        >
                            {
                                isBusy ? <><CircularProgress size={10} />&nbsp;Creating...</> : 'Create Link'
                            }
                        </Button>
                    </DialogActions>
                </Dialog>
                : null
        }

        {
            showAlert
                ? <AlertConfirmModal
                    show={showAlert}
                    setShow={handleCloseConfirmation}
                    modalBody={modalBody}
                />
                : null
        }

        {
            confirmDelete
                ? <AlertConfirmModal
                    show={confirmDelete}
                    setShow={setConfirmDelete}
                    modalBody={modalBody}
                    isConfirm={hasConfirm}
                    useFunction={(e) => handleDelete(e, selectedTrial)}
                />
                : null
        }
    </>;
};

const mapStateToProps = state => {
    return {
        freeTrials: state.promotions.trials,
        isBusy: state.promotions.isBusy,
    };
};

export default connect(mapStateToProps)(TrialLinks);